export default "__VITE_ASSET__CgVnGo7K__"